/**
 * Ecommerce route segments that should NOT be treated as location shortUrls.
 * When adding new ecommerce routes (e.g., /store/newSegment/...), add the segment here
 * to prevent RestaurantContext from trying to find a location with that shortUrl.
 */
export const ECOMM_ROUTE_SEGMENTS = [
  'products',
  'categories',
  'add',
  'checkout',
  'confirm'
]

/**
 * Check if a slug is an ecommerce route segment that should not be treated as a location shortUrl.
 * Handles both static segments (e.g., "products") and legacy group GUIDs (e.g., "group_<guid>").
 */
export const isEcommRouteSegment = (slug: string): boolean =>
  ECOMM_ROUTE_SEGMENTS.includes(slug) || slug.startsWith('group_')
